import React, { useState, useRef, useEffect } from 'react';
import { Check, ChevronDown } from 'lucide-react';
import   './form_style.css'
const MultiSelectForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    countryCode: '+1',
    email: '',
    companyName: '',
    jobTitle: '',
    states: [],
    specialties: [],
    services: [],
    annualRevenue: '',
    comments: '',
    // OTP_DISABLED: otp and phoneVerified fields commented out - re-enable when OTP workflow is needed
    // otp: '',
    // phoneVerified: false,
    consentChecked: false
  });

  // UTM tracking data - stored separately to preserve across form resets
  const [utmData, setUtmData] = useState({
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_content: '',
    utm_term: '',
    gclid: '',
    fbclid: '',
    lead_source: ''
  });

  // Parse UTM parameters from URL - with retry to handle iframe src updates from parent
  useEffect(() => {
    const parseUtmParams = () => {
      const urlParams = new URLSearchParams(window.location.search);

      const utm_source = urlParams.get('utm_source') || '';
      const utm_medium = urlParams.get('utm_medium') || '';
      const utm_campaign = urlParams.get('utm_campaign') || '';
      const utm_content = urlParams.get('utm_content') || '';
      const utm_term = urlParams.get('utm_term') || '';
      const gclid = urlParams.get('gclid') || '';
      const fbclid = urlParams.get('fbclid') || '';

      // Derive lead_source based on available tracking data
      let lead_source = 'Direct';
      if (gclid) {
        lead_source = 'Google Ads';
      } else if (fbclid) {
        lead_source = 'Facebook Ads';
      } else if (utm_source) {
        // Map common utm_source values to readable lead sources
        const sourceMap = {
          'google': 'Google',
          'facebook': 'Facebook',
          'instagram': 'Instagram',
          'linkedin': 'LinkedIn',
          'twitter': 'Twitter',
          'bing': 'Bing',
          'email': 'Email',
          'newsletter': 'Newsletter'
        };
        const sourceLower = utm_source.toLowerCase();
        lead_source = sourceMap[sourceLower] || utm_source;

        // Append medium for more context (e.g., "Google - CPC")
        if (utm_medium) {
          lead_source = `${lead_source} - ${utm_medium.toUpperCase()}`;
        }
      }
      // Note: document.referrer is not used because in iframe context it returns
      // the parent page URL (Webflow), not the actual external referrer.
      // If no UTM params, lead_source stays as "Direct"

      return {
        utm_source,
        utm_medium,
        utm_campaign,
        utm_content,
        utm_term,
        gclid,
        fbclid,
        lead_source
      };
    };

    // Parse immediately
    const initialParams = parseUtmParams();
    setUtmData(initialParams);

    // If no params found, retry after short delays to catch iframe src updates from Webflow
    // This handles the timing issue where Webflow updates iframe src after React mounts
    if (!initialParams.utm_source && !initialParams.gclid && !initialParams.fbclid) {
      const retryDelays = [100, 300, 600, 1000];
      const timeouts = retryDelays.map(delay =>
        setTimeout(() => {
          const params = parseUtmParams();
          // Only update if we found params this time
          if (params.utm_source || params.gclid || params.fbclid) {
            setUtmData(params);
          }
        }, delay)
      );

      // Cleanup timeouts on unmount
      return () => timeouts.forEach(t => clearTimeout(t));
    }
  }, []);

  const [statesOpen, setStatesOpen] = useState(false);
  const [specialtiesOpen, setSpecialtiesOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const [revenueOpen, setRevenueOpen] = useState(false);
  const [countryCodeOpen, setCountryCodeOpen] = useState(false);
  // OTP_DISABLED: OTP state variables commented out - re-enable when OTP workflow is needed
  // const [otpSent, setOtpSent] = useState(false);
  // const [otpVerifying, setOtpVerifying] = useState(false);

  
  // Refs for click-outside handling
  const statesRef = useRef(null);
  const specialtiesRef = useRef(null);
  const servicesRef = useRef(null);
  const revenueRef = useRef(null);
  const countryCodeRef = useRef(null);

  useEffect(() => {
    const sendDimensions = () => {
        const width = document.body.scrollWidth;
        const height = document.body.scrollHeight;
        window.parent.postMessage({ 
            type: 'resize', 
            height,
            width
        }, '*');
    };

    sendDimensions();
       // Send height when window resizes
    window.addEventListener('resize',  sendDimensions);


    const handleClickOutside = (event) => {
      /*
      if (statesRef.current && !statesRef.current.contains(event.target)) {
        setStatesOpen(false);
      }
        */
      

  if (statesRef.current && !statesRef.current.contains(event.target)) {
    setStatesOpen(false);

  }

      if (specialtiesRef.current && !specialtiesRef.current.contains(event.target)) {
        setSpecialtiesOpen(false);

      }
      if (servicesRef.current && !servicesRef.current.contains(event.target)) {
        setServicesOpen(false);
      }

      if (revenueRef.current && !revenueRef.current.contains(event.target)) {
        setRevenueOpen(false);
      }
      if (countryCodeRef.current && !countryCodeRef.current.contains(event.target)) {
        setCountryCodeOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('resize', sendDimensions);
    };

    
  }, []);

  // Your existing state and specialty options
  const states = [
    { value: 'alabama', label: 'Alabama' },
    { value: 'alaska', label: 'Alaska' },
    { value: 'arizona', label: 'Arizona' },
    { value: 'arkansas', label: 'Arkansas' },
    { value: 'california', label: 'California' },
    { value: 'colorado', label: 'Colorado' },
    { value: 'connecticut', label: 'Connecticut' },
    { value: 'delaware', label: 'Delaware' },
    { value: 'florida', label: 'Florida' },
    { value: 'georgia', label: 'Georgia' },
    { value: 'hawaii', label: 'Hawaii' },
    { value: 'idaho', label: 'Idaho' },
    { value: 'illinois', label: 'Illinois' },
    { value: 'indiana', label: 'Indiana' },
    { value: 'iowa', label: 'Iowa' },
    { value: 'kansas', label: 'Kansas' },
    { value: 'kentucky', label: 'Kentucky' },
    { value: 'louisiana', label: 'Louisiana' },
    { value: 'maine', label: 'Maine' },
    { value: 'maryland', label: 'Maryland' },
    { value: 'massachusetts', label: 'Massachusetts' },
    { value: 'michigan', label: 'Michigan' },
    { value: 'minnesota', label: 'Minnesota' },
    { value: 'mississippi', label: 'Mississippi' },
    { value: 'missouri', label: 'Missouri' },
    { value: 'montana', label: 'Montana' },
    { value: 'nebraska', label: 'Nebraska' },
    { value: 'nevada', label: 'Nevada' },
    { value: 'new_hampshire', label: 'New Hampshire' },
    { value: 'new_jersey', label: 'New Jersey' },
    { value: 'new_mexico', label: 'New Mexico' },
    { value: 'new_york', label: 'New York' },
    { value: 'north_carolina', label: 'North Carolina' },
    { value: 'north_dakota', label: 'North Dakota' },
    { value: 'ohio', label: 'Ohio' },
    { value: 'oklahoma', label: 'Oklahoma' },
    { value: 'oregon', label: 'Oregon' },
    { value: 'pennsylvania', label: 'Pennsylvania' },
    { value: 'rhode_island', label: 'Rhode Island' },
    { value: 'south_carolina', label: 'South Carolina' },
    { value: 'south_dakota', label: 'South Dakota' },
    { value: 'tennessee', label: 'Tennessee' },
    { value: 'texas', label: 'Texas' },
    { value: 'utah', label: 'Utah' },
    { value: 'vermont', label: 'Vermont' },
    { value: 'virginia', label: 'Virginia' },
    { value: 'washington', label: 'Washington' },
    { value: 'west_virginia', label: 'West Virginia' },
    { value: 'wisconsin', label: 'Wisconsin' },
    { value: 'wyoming', label: 'Wyoming' }
  ];

  
    const specialties = [
        // { value: 'front_end', label: 'Front-End Billing' },
        // { value: 'mid_end', label: 'Mid-End Billing' },
        // { value: 'back_end', label: 'Back-End Billing' },
        
        { value: 'allergy', label: 'Allergy' },
        { value: 'anesthesiology', label: 'Anesthesiology' },
        { value: 'cardiology', label: 'Cardiology' },
        { value: 'dermatology', label: 'Dermatology' },
        { value: 'emergency_medicine', label: 'Emergency Medicine' },
        { value: 'endocrinology', label: 'Endocrinology' },
        { value: 'family_practice', label: 'Family Practice' },
        { value: 'gastroenterology', label: 'Gastroenterology' },
        { value: 'general_surgery', label: 'General Surgery' },
        { value: 'geriatrics', label: 'Geriatrics' },
        { value: 'hematology', label: 'Hematology' },
        { value: 'hospitalist', label: 'Hospitalist' },
        { value: 'immunology', label: 'Immunology' },
        { value: 'internal_medicine', label: 'Internal Medicine' },
        { value: 'nephrology', label: 'Nephrology' },
        { value: 'neurology', label: 'Neurology' },
        { value: 'ob_gyn', label: 'OB-GYN' },
        { value: 'oncology', label: 'Oncology' },
        { value: 'ophthalmology', label: 'Ophthalmology' },
        { value: 'optometry', label: 'Optometry' },
        { value: 'orthopedics', label: 'Orthopedics' },
        { value: 'otolaryngology', label: 'Otolaryngology' },
        { value: 'pain_management', label: 'Pain Management' },
        { value: 'pathology', label: 'Pathology' },
        { value: 'pediatrics', label: 'Pediatrics' },
        { value: 'physical_therapy', label: 'Physical Therapy' },
        { value: 'podiatry', label: 'Podiatry' },
        { value: 'psychiatry', label: 'Psychiatry' },
        { value: 'psychology', label: 'Psychology' },
        { value: 'pulmonology', label: 'Pulmonology' },
        { value: 'radiation_oncology', label: 'Radiation Oncology' },
        { value: 'radiology', label: 'Radiology' },
        { value: 'rheumatology', label: 'Rheumatology' },
        { value: 'urology', label: 'Urology' },
        { value: 'wound_care', label: 'Wound Care' },
        { value: 'other', label: 'Other' }
    ];
    
  
  const countryCodes = [
    { value: '+1', label: 'USA (+1)', flag: '🇺🇸' },
    { value: '+1-CA', label: 'Canada (+1)', flag: '🇨🇦' },
    { value: '+44', label: 'UK (+44)', flag: '🇬🇧' },
    { value: '+91', label: 'India (+91)', flag: '🇮🇳' },
    { value: '+61', label: 'Australia (+61)', flag: '🇦🇺' },
    { value: '+81', label: 'Japan (+81)', flag: '🇯🇵' },
    { value: '+49', label: 'Germany (+49)', flag: '🇩🇪' },
    { value: '+33', label: 'France (+33)', flag: '🇫🇷' },
    { value: '+39', label: 'Italy (+39)', flag: '🇮🇹' },
    { value: '+34', label: 'Spain (+34)', flag: '🇪🇸' },
    { value: '+86', label: 'China (+86)', flag: '🇨🇳' },
    { value: '+82', label: 'South Korea (+82)', flag: '🇰🇷' },
    { value: '+55', label: 'Brazil (+55)', flag: '🇧🇷' },
    { value: '+52', label: 'Mexico (+52)', flag: '🇲🇽' },
    { value: '+31', label: 'Netherlands (+31)', flag: '🇳🇱' },
    { value: '+46', label: 'Sweden (+46)', flag: '🇸🇪' },
    { value: '+41', label: 'Switzerland (+41)', flag: '🇨🇭' },
    { value: '+65', label: 'Singapore (+65)', flag: '🇸🇬' },
    { value: '+64', label: 'New Zealand (+64)', flag: '🇳🇿' },
    { value: '+353', label: 'Ireland (+353)', flag: '🇮🇪' },
    { value: '+971', label: 'UAE (+971)', flag: '🇦🇪' }
  ];

    const revenueOptions = [
        { value: '<200000', label: '< $200,000' },
        { value: '200000 - 500000', label: '$200,000 - $500,000' },
        { value: '500000-1M', label: '$500,000 - $1,000,000' },
        { value: '1M-5M', label: '$1,000,000 - $5,000,000' },
        { value: '5M-10M', label: '$5,000,000 - $10,000,000' },
        { value: '10M-20M', label: '$10,000,000 - $20,000,000' },
        { value: '> 20M', label: '> $20,000,000' }
      ];

      const services = [
        { value: 'all', label: 'Select All' }, 
        { value: 'eligibility', label: 'Insurance Eligibility and Benefits Verification' },
        { value: 'prior_auth', label: 'Prior Authorization' },
        { value: 'demographics', label: 'Patient Demographic Entry' },
        { value: 'coding', label: 'Medical Coding' },
        { value: 'cdi', label: 'Clinical Documentation Improvement (CDI)' },
        { value: 'audits', label: 'Coding Audits' },
        { value: 'claims', label: 'Claim Submission' },
        { value: 'posting', label: 'Payment Posting' },
        { value: 'balance', label: 'Credit Balance Management' },
        { value: 'denials', label: 'Denial Management' }
      ];

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

const validatePhone = (phone) => {
    // Remove all non-digit characters
    const digitsOnly = phone.replace(/\D/g, '');
    // Check if it's between 7 and 15 digits (international phone number range)
    return digitsOnly.length >= 7 && digitsOnly.length <= 15;
};


const validateForm = () => {
    const errors = {};
    let firstError = null;

    // Sequential validation - checking fields in order of appearance
    if (!formData.firstName) {
        errors.firstName = 'First Name is required';
        firstError = firstError || 'firstName';
    }

    if (!formData.lastName) {
        errors.lastName = 'Last Name is required';
        firstError = firstError || 'lastName';
    }

    if (!formData.phone) {
        errors.phone = 'Phone Number is required';
        firstError = firstError || 'phone';
    } else if (!validatePhone(formData.phone)) {
        errors.phone = 'Please enter a valid phone number';
        firstError = firstError || 'phone';
    }

    // OTP_DISABLED: phone verification check commented out - re-enable when OTP workflow is needed
    // if (!formData.phoneVerified && formData.phone) {
    //     errors.phone = 'Please verify your phone number';
    //     firstError = firstError || 'phone';
    // }

    if (!formData.email) {
        errors.email = 'Email is required';
        firstError = firstError || 'email';
    } else if (!validateEmail(formData.email)) {
        errors.email = 'Please enter a valid email address';
        firstError = firstError || 'email';
    }

    if (!formData.companyName) {
        errors.companyName = 'Company Name is required';
        firstError = firstError || 'companyName';
    }

    if (!formData.jobTitle) {
        errors.jobTitle = 'Job Title is required';
        firstError = firstError || 'jobTitle';
    }

    if (formData.states.length === 0) {
        errors.states = 'Please select at least one state';
        firstError = firstError || 'states';
    }

    if (formData.specialties.length === 0) {
        errors.specialties = 'Please select at least one specialty';
        firstError = firstError || 'specialties';
    }

    if (formData.services.length === 0) {
        errors.services = 'Please select at least one service';
        firstError = firstError || 'services';
    }

    if (!formData.annualRevenue) {
        errors.annualRevenue = 'Annual Revenue is required';
        firstError = firstError || 'annualRevenue';
    }
    
    if (!formData.consentChecked) {
        errors.consentChecked = 'Please check the consent box to proceed.';
        firstError = firstError || 'consentChecked';
    }
    
    setFormErrors(errors);

    // If there's an error, scroll to the first error field
    if (firstError) {
        const element = document.getElementById(firstError);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            element.focus();
        }
    }

    return Object.keys(errors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setSubmitStatus('submitting');

    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
    
    // Google Analytics tracking for form submission
    if (window.gtag) {
      window.gtag('event', 'form_submit', {
        event_category: 'engagement',
        event_label: 'turmeric_billing_form',
        form_data: {
          states_count: formData.states.length,
          specialties_count: formData.specialties.length,
          services_count: formData.services.length,
          revenue_range: formData.annualRevenue
        }
      });
    }
      // You can replace this URL with your serverless function endpoint
      // or Google Sheets API endpoint
    try {
        const response = await fetch('/api/submit', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              ...formData,
              ...utmData,
              submittedAt: new Date().toISOString(),
              source: window.location.href
            }),
          });
         
           // Log the full response for debugging
  const responseText = await response.text();
  console.log('Server response:', response.status, responseText);

          if (!response.ok) {
    let errorMessage;
    try {
      const errorData = JSON.parse(responseText);
      errorMessage = errorData.error || 'Submission failed';
    } catch (e) {
      errorMessage = responseText || 'Submission failed';
    }
    throw new Error(errorMessage);
  }

      
        setSubmitStatus('success');

        // Google Ads conversion tracking
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            'send_to': 'AW-17474241432/EM3ACPaLnOkbEJiHr4xB'
          });
        }

        // LinkedIn conversion tracking
        if (window.lintrk) {
          window.lintrk('track', { conversion_id: 25847402 });
        }

        // Reset form after a delay to show success message
        setTimeout(() => {
          setFormData({
            firstName: '',
            lastName: '',
            phone: '',
            countryCode: '+1',
            email: '',
            companyName: '',
            jobTitle: '',
            states: [],
            specialties: [],
            services: [],
            annualRevenue: '',
            comments: '',
            // OTP_DISABLED: otp: '', phoneVerified: false,
            consentChecked: false
          });
          // OTP_DISABLED: setOtpSent(false);
          // Clear success message after form reset
          setTimeout(() => setSubmitStatus(''), 3000);
        }, 2000);
    

    }catch (error) {
      console.error('Submission error:', error);
      setSubmitStatus('error');
    }
  };
  const toggleState = (value) => {
    const newStates = formData.states.includes(value)
      ? formData.states.filter(state => state !== value)
      : [...formData.states, value];
    setFormData({...formData, states: newStates});
  };

const toggleSpecialty = (value) => {
    const newSpecialties = formData.specialties.includes(value)
      ? formData.specialties.filter(specialty => specialty !== value)
      : [...formData.specialties, value];
    setFormData({...formData, specialties: newSpecialties});
  };

  const toggleService = (value) => {
    let newServices;
    if (value === 'all') {
      // If Select All is clicked
      if (formData.services.length === services.length - 1) { // -1 because we don't count the "Select All" option
        newServices = []; // Deselect all if everything was selected
      } else {
        newServices = services.filter(s => s.value !== 'all').map(s => s.value); // Select all except "Select All" option
      }
    } else {
      // Regular toggle for individual services
      newServices = formData.services.includes(value)
        ? formData.services.filter(service => service !== value)
        : [...formData.services, value];
    }
    setFormData({...formData, services: newServices});
  };

  /* OTP_DISABLED: sendOTP and verifyOTP functions commented out - re-enable when OTP workflow is needed
  const sendOTP = async () => {
    if (!formData.phone || !validatePhone(formData.phone)) {
      setFormErrors({ phone: 'Please enter a valid phone number' });
      return;
    }

    // Google Analytics tracking for OTP request
    if (window.gtag) {
      window.gtag('event', 'otp_requested', {
        event_category: 'engagement',
        event_label: 'phone_verification',
        country_code: formData.countryCode
      });
    }

    try {
      const response = await fetch('/api/send-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          countryCode: formData.countryCode.replace('-CA', ''),
          phoneNumber: formData.phone
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setOtpSent(true);
        setFormErrors({});
        // Clear any previous OTP
        setFormData({...formData, otp: ''});
      } else {
        setFormErrors({ phone: data.error || 'Failed to send OTP' });
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
      setFormErrors({ phone: 'Failed to send OTP. Please try again.' });
    }
  };

  const verifyOTP = async () => {
    if (!formData.otp) {
      setFormErrors({ otp: 'Please enter the OTP' });
      return;
    }

    setOtpVerifying(true);

    try {
      const response = await fetch('/api/verify-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          countryCode: formData.countryCode.replace('-CA', ''),
          phoneNumber: formData.phone,
          code: formData.otp
        }),
      });

      const data = await response.json();

      if (response.ok && data.verified) {
        setFormData({...formData, phoneVerified: true});
        setFormErrors({});
        setOtpSent(false);

        // Google Analytics tracking for successful OTP verification
        if (window.gtag) {
          window.gtag('event', 'otp_verified', {
            event_category: 'engagement',
            event_label: 'phone_verification_success'
          });
        }
      } else {
        setFormErrors({ otp: data.message || 'Invalid OTP. Please try again.' });

        // Google Analytics tracking for failed OTP verification
        if (window.gtag) {
          window.gtag('event', 'otp_failed', {
            event_category: 'engagement',
            event_label: 'phone_verification_failed'
          });
        }
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      setFormErrors({ otp: 'Failed to verify OTP. Please try again.' });
    } finally {
      setOtpVerifying(false);
    }
  };
  OTP_DISABLED */

  
  return (
    <div className="w-full max-w-full sm:py-4 sm:px-4 ">
    <div className="  mx-auto tw-border tw-rounded-1 my-element py-6 px-6 sm:px-6 md:px-8 ">
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Personal Information Section */}
      <div className="border-b-2 border-gray-200 pb-6 mb-6">
        <h2 className="text-xl font-bold mb-4 text-gray-800">Personal Information</h2>
        
        {/* Basic Information */}
        <div className="grid grid-cols-1 gap-5 md:grid-col-2">
        <div className="flex flex-col">
          <label htmlFor="firstName" className="label_input">First Name<span class="sup">*</span></label>
          <input
            id="firstName"
            type="text"
            value={formData.firstName}
            onChange={(e) => setFormData({...formData, firstName: e.target.value})}
            className="p-2 border  min40"
            required
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="lastName" className="label_input">Last Name<span class="sup">*</span></label>
          <input
            id="lastName"
            type="text"
            value={formData.lastName}
            onChange={(e) => setFormData({...formData, lastName: e.target.value})}
            className="p-2 border  min40"
            required
          />
        </div>
      </div>

      {/* Contact Information */}
      <div className="grid grid-cols-1 gap-5 md:grid-col-2">
        <div className="flex flex-col">
          <label htmlFor="phone" className="label_input">Phone Number<span class="sup">*</span></label>
          <div className="flex flex-col  gap-2">
            {/* Country Code Dropdown */}
            <div className="flex gap-2">
            <div className="relative" ref={countryCodeRef}>
              <button
                type="button"
                onClick={() => setCountryCodeOpen(!countryCodeOpen)}
                className="p-2 border min40 flex items-center gap-2 bg-white"
                style={{ minWidth: '120px' }}
              >
                <span>{countryCodes.find(c => c.value === formData.countryCode)?.flag}</span>
                <span>{formData.countryCode.replace('-CA', '')}</span>
                <ChevronDown className={`transform transition-transform ${countryCodeOpen ? 'rotate-180' : ''}`} size={16} />
              </button>
              {countryCodeOpen && (
                <div className="absolute z-10 w-full mt-1 bg-white border shadow-lg max-h-60 overflow-auto">
                  {countryCodes.map((country) => (
                    <div
                      key={country.value}
                      className="p-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2"
                      onClick={() => {
                        setFormData({...formData, countryCode: country.value});
                        setCountryCodeOpen(false);
                        // OTP_DISABLED: setOtpSent(false);
                      }}
                    >
                      <span>{country.flag}</span>
                      <span>{country.label}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            {/* Phone Number Input */}
            <div className="flex-1">
              <input
                id="phone"
                type="tel"
                value={formData.phone}
                onChange={(e) => {
                  setFormData({...formData, phone: e.target.value});
                  // OTP_DISABLED: setOtpSent(false);
                }}
                placeholder="(555) 123-4567"
                className="p-2 border min40 w-full"
                required
              />
            </div>
            </div>
            {/* OTP_DISABLED: Send OTP button, Verified badge, OTP input field commented out - re-enable when OTP workflow is needed */}
            {/*
            {!formData.phoneVerified && (
              <button
                type="button"
                onClick={sendOTP}
                className="p-2 px-4 shine-button text-white rounded min40"
                disabled={!formData.phone || otpSent}
                style={{ backgroundColor: '#f25939' }}
              >
                {otpSent ? 'Resend OTP' : 'Send OTP'}
              </button>
            )}

            {formData.phoneVerified && (
              <div className="flex items-center text-green-600">
                <Check size={20} className="mr-1" />
                <span>Verified</span>
              </div>
            )}
            */}
          </div>
          {formErrors.phone && (
            <span className="text-red-500 text-sm mt-1">{formErrors.phone}</span>
          )}

          {/* OTP_DISABLED: OTP input field and error display commented out - re-enable when OTP workflow is needed */}
          {/*
          {otpSent && !formData.phoneVerified && (
            <div className="mt-3 flex gap-2">
              <input
                type="text"
                value={formData.otp}
                onChange={(e) => setFormData({...formData, otp: e.target.value})}
                placeholder="Enter 6-digit OTP"
                className="p-2 border min40 flex-1"
                maxLength="6"
              />
              <button
                type="button"
                onClick={verifyOTP}
                className="p-2 px-4 bg-green-600 text-white rounded hover:bg-green-700 min40"
                disabled={otpVerifying || !formData.otp}
              >
                {otpVerifying ? 'Verifying...' : 'Verify OTP'}
              </button>
            </div>
          )}
          {formErrors.otp && (
            <span className="text-red-500 text-sm mt-1">{formErrors.otp}</span>
          )}
          */}
        </div>
        <div className="flex flex-col">
          <label htmlFor="email" className="label_input">Email Address<span class="sup">*</span></label>
          <input
            id="email"
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({...formData, email: e.target.value})}
            className="p-2 border min40"
            required
          />
          {formErrors.email && (
            <span className="text-red-500 text-sm mt-1">{formErrors.email}</span>
          )}
        </div>
      </div>
      </div>

      {/* Company & Service Information Section */}
      <div className="border-b-2 border-gray-200 pb-6 mb-6">
        <h2 className="text-xl font-bold mb-4 text-gray-800">Company & Service Information</h2>
        
        {/* Company Information */}
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        <div className="flex flex-col">
          <label htmlFor="companyName" className="label_input">Company Name<span class="sup">*</span></label>
          <input
            id="companyName"
            type="text"
            value={formData.companyName}
            onChange={(e) => setFormData({...formData, companyName: e.target.value})}
            className="p-2 border  min40"
          />
          {formErrors.companyName && (
            <span className="text-red-500 text-sm mt-1">{formErrors.companyName}</span>
          )}
        </div>
        <div className="flex flex-col">
          <label htmlFor="jobTitle" className="label_input">Job Title<span class="sup">*</span></label>
          <input
            id="jobTitle"
            type="text"
            value={formData.jobTitle}
            onChange={(e) => setFormData({...formData, jobTitle: e.target.value})}
            className="p-2 border  min40"
          />
          {formErrors.jobTitle && (
            <span className="text-red-500 text-sm mt-1">{formErrors.jobTitle}</span>
          )}
        </div>
      </div>
      
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-5">
        {/* States Dropdown */}
        
        <div className="relative" >
          <label className="block label_input">
            State<span className="text-red-500">*</span>
          </label>
          <div  ref={statesRef}>
          <button
            type="button"
            onClick={() => setStatesOpen(!statesOpen)}
            className="w-full p-2 border  min40 flex justify-between items-center bg-white"
           
          >
            <span class="fade-text">{formData.states.length ? `${formData.states.length} states selected` : 'Select Multiple States'}</span>
            <ChevronDown className={`transform transition-transform ${statesOpen ? 'rotate-180' : ''}`} />
          </button>
          {statesOpen && (
            <div className="absolute z-10 w-full mt-1 bg-white border  shadow-lg max-h-60 overflow-auto">
              {states.map((state) => (
                <div
                  key={state.value}
                  className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
                  onClick={(e) => {
    e.stopPropagation();
    toggleState(state.value);
  }}
                >
                  <div className="w-4 h-4 border rounded mr-2 flex items-center justify-center">
                    {formData.states.includes(state.value) && <Check size={14} />}
                  </div>
                  {state.label}
                </div>
              ))}
            </div>
          )}
          </div>
          {formErrors.states && (
            <span className="text-red-500 text-sm mt-1">{formErrors.states}</span>
          )}
        </div>

       

      
<div className="relative" >
  <label className="block label_input">
    Services interested in<span className="text-red-500">*</span>
  </label>
  <div  ref={servicesRef}>
  <button
    type="button"
    onClick={() => setServicesOpen(!servicesOpen)}
    className="w-full p-2 border min40 flex justify-between items-center bg-white"
   
  >
    <span class="fade-text">{formData.services.length ? `${formData.services.length} services selected` : 'Select Multiple Services'}</span>
    <ChevronDown className={`transform transition-transform ${servicesOpen ? 'rotate-180' : ''}`} />
  </button>
  {servicesOpen && (
    <div className="absolute z-10 w-full mt-1 bg-white border shadow-lg max-h-60 overflow-auto">
      {services.map((service) => (
        <div
          key={service.value}
          className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
          onClick={() => toggleService(service.value)}
        >
          <div className="w-4 h-4 border rounded mr-2 flex items-center justify-center">
            {service.value === 'all' 
              ? formData.services.length === services.length - 1 && <Check size={14} />
              : formData.services.includes(service.value) && <Check size={14} />
            }
          </div>
          {service.label}
        </div>
      ))}
    </div>
  )}
  </div>
  {formErrors.services && (
    <span className="text-red-500 text-sm mt-1">{formErrors.services}</span>
  )}
        </div>
      </div>
      
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        {/* Specialties Dropdown */}
        <div className="relative" >
          <label className="block label_input">
            Specialty Type<span className="text-red-500">*</span>
          </label>
          <div  ref={specialtiesRef}>
          <button
            type="button"
            onClick={() => setSpecialtiesOpen(!specialtiesOpen)}
            className="w-full p-2 border  min40 flex justify-between items-center bg-white"
            
          >
            <span class="fade-text">{formData.specialties.length ? `${formData.specialties.length} specialties selected` : 'Select Multiple Specialties'}</span>
            <ChevronDown className={`transform transition-transform ${specialtiesOpen ? 'rotate-180' : ''}`} />
          </button>
          {specialtiesOpen && (
            <div className="absolute z-10 w-full mt-1 bg-white border  shadow-lg max-h-60 overflow-auto">
              {specialties.map((specialty) => (
                <div
                  key={specialty.value}
                  className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => toggleSpecialty(specialty.value)}
                >
                  <div className="w-4 h-4 border rounded mr-2 flex items-center justify-center">
                    {formData.specialties.includes(specialty.value) && <Check size={14} />}
                  </div>
                  {specialty.label}
                </div>
              ))}
            </div>
          )}
          </div>
          {formErrors.specialties && (
            <span className="text-red-500 text-sm mt-1">{formErrors.specialties}</span>
          )}
        </div>
   
   
   
       {/* Annual Revenue Dropdown */}
<div className="relative" ref={revenueRef}>
  <label className="block label_input">
    Annual Revenue<span className="text-red-500">*</span>
  </label>
  <div   ref={revenueRef}>
  <button
    type="button"
    id="annualRevenue"
    onClick={() => setRevenueOpen(!revenueOpen)}
    className="w-full p-2 border min40 flex justify-between items-center bg-white"
   
  >
    <span class="fade-text">
      {formData.annualRevenue 
        ? revenueOptions.find(opt => opt.value === formData.annualRevenue)?.label 
        : 'Select Annual Revenue'}
    </span>
    <ChevronDown className={`transform transition-transform ${revenueOpen ? 'rotate-180' : ''}`} />
  </button>
  {revenueOpen && (
    <div className="absolute z-10 w-full mt-1 bg-white border shadow-lg max-h-60 overflow-auto">
      {revenueOptions.map((option) => (
        <div
          key={option.value}
          className="p-2 hover:bg-gray-100 cursor-pointer"
          onClick={() => {
            setFormData({...formData, annualRevenue: option.value});
            setRevenueOpen(false);
          }}
        >
          {option.label}
        </div>
      ))}
    </div>
  )}
  </div>
  {formErrors.annualRevenue && (
    <span className="text-red-500 text-sm mt-1">{formErrors.annualRevenue}</span>
  )}
        </div>
      </div>
      </div>

      {/* Additional Information Section */}
      <div className="">
        <h2 className="text-xl font-bold mb-4 text-gray-800">Additional Information</h2>
        
        {/* Comments */}
        <div className="flex flex-col tw-mb-5">
        <label htmlFor="comments" className="label_input">Let us know how we can help</label>
        <textarea
          id="comments"
          value={formData.comments}
          onChange={(e) => setFormData({...formData, comments: e.target.value})}
          className="w-full p-2 border rounded h-24"
        />
        </div>
      </div>

      {/* Consent Checkbox */}
      <div className="flex items-start mb-4">
        <input
          type="checkbox"
          id="consentChecked"
          checked={formData.consentChecked}
          onChange={(e) => setFormData({...formData, consentChecked: e.target.checked})}
          className=" mr-2 w-6 h-6"
        />
        <label htmlFor="consentChecked" className="text-sm">
         By checking this box, I consent to receive Marketing related SMS messages from Turmeric Billing , including discounts, and special offers, at the phone number provided above. The SMS frequency may vary. Data rates may apply. For assistance reply HELP. Reply STOP to opt out of receiving SMS messages.  {' '}
          <a href="https://www.turmericbilling.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Privacy Policy</a>
          {' '}
          <a href="https://www.turmericbilling.com/terms-and-conditions" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Terms and Conditions</a>
        </label>
      </div>
      {formErrors.consentChecked && (
        <div className="text-red-500 text-sm mb-4">{formErrors.consentChecked}</div>
      )}

      {/* Submit Button */}
      <div class="tw-w-full tw-flex tw-flex-row tw-justify-center">
      <button
        type="submit"
        disabled={submitStatus === 'submitting'}
        className="tw-w-330 tw-mx-auto  shine-button  py-3 px-4 "
        
      >
        {submitStatus === 'submitting' ? 'Submitting...' : 'Submit Request'}
      </button>
      </div>

      <div class="tw-w-full tw-flex tw-flex-row tw-justify-center p-2">
      {/* Status Messages */}
      {submitStatus === 'success' && (
        <div
          style={{
            backgroundColor: '#ffeae5',
            border: '2px solid #f25939',
            borderRadius: '12px',
            padding: '24px 32px',
            textAlign: 'center',
            maxWidth: '400px',
            margin: '0 auto',
            boxShadow: '0 4px 12px rgba(242, 89, 57, 0.15)'
          }}
        >
          <div
            style={{
              width: '48px',
              height: '48px',
              backgroundColor: '#f25939',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px'
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
          <h3
            style={{
              color: '#1b6c86',
              fontSize: '22px',
              fontWeight: '700',
              margin: '0 0 8px 0'
            }}
          >
            Thank You!
          </h3>
          <p
            style={{
              color: '#1b6c86',
              fontSize: '15px',
              margin: '0',
              opacity: 0.85
            }}
          >
            Your request has been submitted successfully. We'll be in touch shortly.
          </p>
        </div>
      )}
      {submitStatus === 'error' && (
        <div
          style={{
            backgroundColor: '#fef2f2',
            border: '2px solid #dc2626',
            borderRadius: '12px',
            padding: '16px 24px',
            textAlign: 'center',
            maxWidth: '400px',
            margin: '0 auto'
          }}
        >
          <p style={{ color: '#dc2626', fontSize: '15px', margin: 0, fontWeight: '500' }}>
            Error submitting form. Please try again.
          </p>
        </div>
      )}
      </div>
    </form>
  </div>
  </div>
  );
};

export default MultiSelectForm;